// Generated by volt_bundle from *.volt-entrypoint.tsx discovery. Do not edit.
import ProjectPageEntrypoint from '@townsquare/project-view/entrypoint';
import type { Entrypoint } from '@townsquare/router/volt/types';

const entrypointRegistry: Record<string, Entrypoint> = {
	ProjectPageEntrypoint,
};

export default entrypointRegistry;
